"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _ykbUtils = require("ykb-utils");
var _ykbStyledComponents = require("../ykb-styled-components");
var _LocaleContext = require("../locales/LocaleContext");
var _default2 = _interopRequireDefault(require("../locales/default"));
var _en = _interopRequireDefault(require("../locales/en"));
var _index = _interopRequireDefault(require("./index"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Button = _interopRequireDefault(require("../Button"));
var _ykbIntl = require("ykb-intl");
var _StyledMessage = require("./StyledMessage");
var _excluded = ["config", "close", "allowOverflow"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Alternatif çözüm üretilebilirse geri eklenebilir.
// const createShadow = mountEl => {
//   const parent = document.createElement('div');
//   document.body.appendChild(parent);

//   const shadowRoot = parent.attachShadow({ mode: 'open' });

//   Object.defineProperty(mountEl, 'ownerDocument', {
//     value: shadowRoot,
//   });

//   shadowRoot.createElement = (...args) => document.createElement(...args);
//   shadowRoot.createElementNS = (...args) => document.createElementNS(...args);
//   shadowRoot.createTextNode = (...args) => document.createTextNode(...args);
//   shadowRoot.defaultView = shadowRoot.defaultView ? shadowRoot.defaultView : {};

//   shadowRoot.defaultView['getComputedStyle'] = (...args) =>
//     window.getComputedStyle(...args);

//   return shadowRoot;
// };

function notify(config) {
  var targetElement = document.body;
  var div;
  var styleContainer;
  // targetElement = config.getContainer
  //   ? config.getContainer()
  //   : containerChecker(); // for harmoni web-component check
  if (config.getContainer) {
    targetElement = config.getContainer();
  }
  if (targetElement.ownerDocument && targetElement.ownerDocument.host) {
    div = targetElement.ownerDocument.createElement('div');
    styleContainer = targetElement.ownerDocument.createElement('div');
    Object.defineProperty(div, 'ownerDocument', {
      value: targetElement.ownerDocument
    });
    Object.defineProperty(styleContainer, 'ownerDocument', {
      value: targetElement.ownerDocument
    });
  } else {
    div = document.createElement('div');
    div.classList.add('renderOnBody');
    styleContainer = document.createElement('div');
    targetElement = document.body;
  }
  targetElement.appendChild(div);
  targetElement.appendChild(styleContainer);
  function close(params) {
    var _params$e;
    var unmountResult = _reactDom.default.unmountComponentAtNode(div);
    if (unmountResult && div.parentNode) {
      div.parentNode.removeChild(div);
    }

    // e targetı svg ise modal ikona basılarak kapatılmıs demektir.
    // icondan kapatıldı ise bu metod ile detect edilebilir
    if ((params === null || params === void 0 ? void 0 : (_params$e = params.e) === null || _params$e === void 0 ? void 0 : _params$e.type) == 'close-icon') {
      if (config.onCloseWithIcon) {
        config.onCloseWithIcon();
      }
    }
    if (config.onClose) {
      config.onClose(params === null || params === void 0 ? void 0 : params.e);
    }
    if (params && params.triggerCancel && config.onCancel) {
      config.onCancel();
    }
  }
  var languageCode = (0, _ykbIntl.getLanguageCode)();
  var localeOptions = {};
  if (languageCode !== 'tr') {
    localeOptions = {
      locale: _en.default
    };
  }
  _reactDom.default.render(/*#__PURE__*/_react.default.createElement(_LocaleContext.LocaleProvider, localeOptions, /*#__PURE__*/_react.default.createElement(Message, {
    config: config,
    close: close,
    onClose: function onClose(e) {
      return close({
        triggerCancel: true,
        e: e
      });
    },
    icon: config.icon,
    renderOnBody: true,
    getBodyTarget: function getBodyTarget() {
      return styleContainer;
    },
    getBodyContainer: function getBodyContainer() {
      return div;
    },
    allowOverflow: config.allowOverflow
  })), div);
  return {
    close: close.bind(this)
  };
}
function Message(_ref) {
  var config = _ref.config,
    close = _ref.close,
    allowOverflow = _ref.allowOverflow,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_LocaleContext.LocaleReceiver, {
    componentName: "Modal",
    defaultLocale: _default2.default.Modal
  }, function (localeCode, locale) {
    return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
      var _config$alignContentV;
      var templateOptions = findTemplateFromMessageType(config, close, locale);
      var props = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, config), rest), templateOptions), {}, {
        alignContentVertically: (_config$alignContentV = config.alignContentVertically) !== null && _config$alignContentV !== void 0 ? _config$alignContentV : true
      });
      return /*#__PURE__*/_react.default.createElement(_index.default, (0, _extends2.default)({
        visible: true,
        footer: props.footer,
        title: props.title,
        className: props.className,
        close: close,
        allowOverflow: allowOverflow
      }, props, {
        type: ""
      }), /*#__PURE__*/_react.default.createElement(_StyledMessage.StyledMessage, {
        $hasIcon: !!props.icon,
        theme: theme,
        $alignContentVertically: props.alignContentVertically
      }, renderMessageContent(props)));
    });
  });
}
function renderMessageContent(args) {
  var iconNode = null;
  if (args.icon) {
    iconNode = /*#__PURE__*/_react.default.createElement("div", {
      className: "icon"
    }, args.icon);
  }
  return /*#__PURE__*/_react.default.createElement("div", null, iconNode, /*#__PURE__*/_react.default.createElement("div", {
    className: "content"
  }, " ", args.content));
}
function findTemplateFromMessageType(config, fnModalClose, locale) {
  var _this = this;
  var type = config.type,
    footer = config.footer;
  var notificationData = null;
  var getFooter = function getFooter(hasCancel) {
    var defaultFooter = [/*#__PURE__*/_react.default.createElement(_Button.default, {
      type: "primary",
      key: "save",
      onClick: okHandler.bind(_this)
    }, config.okText ? config.okText : locale.okText)];
    if (hasCancel) {
      defaultFooter.splice(0, 0, /*#__PURE__*/_react.default.createElement(_Button.default, {
        key: "cancel",
        onClick: cancelHandler.bind(_this)
      }, config.cancelText ? config.cancelText : locale.cancelText));
    }
    return defaultFooter;
  };
  var cancelHandler = function cancelHandler() {
    fnModalClose();
    if (config.onCancel) {
      config.onCancel();
    }
  };
  var okHandler = function okHandler() {
    fnModalClose();
    if (config.onOk) {
      config.onOk();
    }
  };
  var getPreparedFooter = function getPreparedFooter(showCancel) {
    if (/*#__PURE__*/_react.default.isValidElement(footer)) return /*#__PURE__*/_react.default.cloneElement(footer, {
      close: fnModalClose
    });
    if (typeof footer === 'function') return footer(fnModalClose);
    return getFooter(showCancel);
  };
  switch (type) {
    case 'info':
      notificationData = {
        icon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
          name: "info-circle",
          colorType: "primary"
        }),
        footer: getPreparedFooter(config.showCancel)
      };
      break;
    case 'success':
      notificationData = {
        icon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
          name: "check-circle",
          colorType: "success"
        }),
        footer: getPreparedFooter(config.showCancel)
      };
      break;
    case 'warning':
      notificationData = {
        icon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
          name: "warning-circle",
          colorType: "warning"
        }),
        footer: getPreparedFooter(config.showCancel)
      };
      break;
    case 'error':
      notificationData = {
        icon: /*#__PURE__*/_react.default.createElement(_Icon.default, {
          name: "close-circle",
          colorType: "danger"
        }),
        footer: getPreparedFooter(config.showCancel)
      };
      break;
    case 'prompt':
      notificationData = {
        footer: getPreparedFooter(true)
      };
      break;
    default:
      notificationData = {};
  }
  return notificationData;
}
var methods = ['info', 'success', 'error', 'warning', 'prompt'];
var messageMethods = {};
methods.map(function (type) {
  return messageMethods[type] = function (args) {
    return notify(_objectSpread(_objectSpread({}, args), {}, {
      type: type
    }));
  };
});
var _default = exports.default = messageMethods;